type CloudflareImageLoaderParams = {
  src: string;
  width: number;
  baseDomain: string;
};

const cloudflareImagesLoader = ({
  src,
  width,
  baseDomain,
}: CloudflareImageLoaderParams): string => {
  if (!baseDomain || !src) return "";

  return src
    .replace("https://imagedelivery.net", `${baseDomain}/cdn-cgi/imagedelivery`)
    .replace(/\/w=\d+$/, `/w=${width}`);
};

export default cloudflareImagesLoader;
